// extracted by mini-css-extract-plugin
export default {"container":"Preview-module--container--224cb","inactive":"Preview-module--inactive--e7aab","device":"Preview-module--device--788ad"};